import { brandPalette } from "../../constants/brandPalette";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent, 
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";

const MainModel = ({
  header,
  openVar,
  children,
  buttonTitle,
  buttonFunc,
  closeFunc,
  isLoading = false,
  size = "4xl",
  extraButtons,
  contentProps,
  headerProps,
  bodyProps,
  footerProps,
  hideDefaultFooter = false,
  cancelTitle = "Cancel",
}) => {
  const { onClose } = useDisclosure();

  return (
    <Modal
      isOpen={openVar}
      onClose={onClose}
      closeOnOverlayClick={true}
      size={size}
    >
      <ModalOverlay />
      <ModalContent bg="white" {...contentProps}>
        <ModalHeader {...headerProps}>{header}</ModalHeader>
        <ModalBody {...bodyProps}>{children}</ModalBody>
        {!hideDefaultFooter && (
          <ModalFooter
            justifyContent="center"
            flexDirection="column"
            gap={4}
            {...footerProps}
          >
            {extraButtons && extraButtons}
            {buttonTitle && (
              <Button
                isLoading={isLoading}
                onClick={() => buttonFunc()}
                color="white"
                bg={brandPalette.secondary}
                borderRadius="12px"
                fontWeight="800"
                minH="44px"
                px={8}
                minW="200px"
                type="submit"
                boxShadow="0 10px 24px rgba(91, 13, 22, 0.28)"
                _hover={{ bg: brandPalette.primary }}
                _active={{ bg: "#6B121F" }}
                _focus={{ outline: "none", boxShadow: "0 0 0 3px rgba(91, 13, 22, 0.35)" }}
              >
                {buttonTitle}
              </Button>
            )}
            <Button
              onClick={closeFunc}
              variant="outline"
              borderRadius="12px"
              fontWeight="800"
              minH="44px"
              px={8}
              borderColor={brandPalette.stone}
              color={brandPalette.primary}
              bg="rgba(255,255,255,0.72)"
              minW="200px"
              _hover={{ bg: "white", borderColor: brandPalette.primary }}
              _focus={{ outline: "none", boxShadow: "0 0 0 3px rgba(91, 13, 22, 0.18)" }}
            >
              {cancelTitle}
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default MainModel;
